export default __webpack_public_path__ + "static/media/angled-foregrip-flat.a35ef6fd.svg";